import React from 'react';
import { Card, Alert, Button } from 'antd';
import CommonHeader from './CommonHeader';
import { useNavigate } from 'react-router-dom';
import { useVerificationStatus } from '../context/VerificationStatusContext';
import styles from './VerificationRejected.module.scss';

const VerificationRejected: React.FC = () => {
  const navigate = useNavigate();
  const { rejectionReason } = useVerificationStatus();

  const handleResubmit = () => {
    navigate('/profile');
  };

  return (
    <div className="signup-container">
      <CommonHeader showNavigation={true} disableNavLinks={true} />
      
      <main className="signup-main profilePage">
        <div className={styles.rejectionContainer}>
          <Card className={styles.rejectionCard}>
            <div className={styles.rejectionHeader}>
              <h1 className={styles.rejectionTitle}>Verification Status</h1>
            </div>
            
            <div className={styles.statusSection}>
              <h2 className={styles.statusLabel}>Verification Rejected</h2>
              
              <Alert
                message="Verification failed. Please review the reasons below and resubmit"
                type="error"
                showIcon
                className={styles.statusAlert}
              />
              
              <div className={styles.rejectionReasonContainer}>
                <p className={styles.rejectionReasonLabel}>Reason for Rejection:</p>
                <p className={styles.rejectionReasonText}>{rejectionReason || 'No reason provided'}</p>
              </div>
              
              <div className={styles.resubmitButtonContainer}>
                <Button
                  type="primary"
                  onClick={handleResubmit}
                  size="large"
                >
                  Resubmit
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default VerificationRejected;
